<template>
  <div class="element-wrapper">
    <div v-if="loading">loading</div>
    <div class="bg-element-wrapper" v-else>
      <img v-if="isImage" :src="url" style="width: 100%; height: 100%" />
      <div v-if="isVideo">
        <video-player class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @ready="playerReadied">
        </video-player>
      </div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
/**
 * @example https://docs.videojs.com/tutorial-options.html
 * @description https://github.com/surmon-china/vue-video-player#readme
 */
import { videoPlayer } from 'vue-video-player'
import { handleRepairePublicPrefix } from '@/util'

export default {
  name: 'PreScene',
  data: () => {
    return {
      loading: true,
      isImage: false,
      isVideo: false,
      url: null,
      playerOptions: {
        width: 1920,
        height: 1080,
        muted: true,
        controls: false,
        autoplay: true,
        loop: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
          // src: 'http://127.0.0.1:7001/public/test.mp4'
        }]
        // poster: '/static/images/author.jpg'
      }
    }
  },
  methods: {
    init () {
      if (!this.preSceneElement) return
      this.isImage = this.preSceneElement.fileType === 'image'
      this.isVideo = this.preSceneElement.fileType === 'video'
      this.url = handleRepairePublicPrefix(this.preSceneElement.filePath)
      if (this.isVideo) {
        this.playerOptions.sources[0].src = this.url
      }
      this.loading = false
    },
    // player is ready
    playerReadied(player) {
      // console.log('the player is readied', player)
      // player.autoplay('muted');
      // you can use it to do something...
      // player.[methods]
    }
  },
  props: {
    preSceneElement: {
      type: Object,
      default: null,
      require: true
    },
    sceneOption: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {
    global() {
      return this.$EventBus
    },
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  mounted() {
    this.init()
  },
  components: {
    videoPlayer
  }
}
</script>

<style lang='less' scoped>
.element-wrapper,
.bg-element-wrapper {
  width: 100%;
  height: 100%;
}
</style>
